var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorLoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 132,
    viewBox: "0 0 133 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1475_223747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.231 109.746C134.391 85.5856 134.391 46.4144 110.231 22.2544C86.071 -1.90567 46.8998 -1.90567 22.7398 22.2544C-1.42028 46.4144 -1.42028 85.5856 22.7398 109.746C46.8998 133.906 86.071 133.906 110.231 109.746Z",
    fill: "#FF6F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 41L91.5 91",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 41L41.5 91",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1475_223747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLoad);
export default __webpack_public_path__ + "static/media/ErrorLoad.19ce8100b899bd4f8c236357090172ac.svg";
export { ForwardRef as ReactComponent };